var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4995_34422)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    rx: 24,
    fill: "#0061FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.56 75.9944L49.674 19.1083L42.3498 18.6172L37.1016 21.5753L36.4818 32.9343L25.5664 65.226L71.9869 111.647L106.56 75.9944Z",
    fill: "#004FCF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4995_34422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.2454 32.6658C61.1891 31.7139 60.4104 30.9719 59.4699 30.9736H52.3679V25.5731C52.3679 20.6021 48.3933 16.5723 43.4903 16.5723C38.5874 16.5723 34.6128 20.6021 34.6128 25.5731V30.9736H27.5107C26.5703 30.9719 25.7916 31.7139 25.7352 32.6658L24.1728 61.2705C24.0061 64.2483 26.2519 66.7994 29.1889 66.9684C29.2922 66.9743 29.3958 66.9773 29.4993 66.977H57.4991C60.4409 66.9819 62.8294 64.5678 62.8342 61.5852C62.8344 61.4802 62.8315 61.3752 62.8256 61.2705L61.2454 32.6658ZM38.1638 25.5731C38.1638 22.5905 40.5485 20.1726 43.4903 20.1726C46.4321 20.1726 48.8169 22.5905 48.8169 25.5731V30.9736H38.1638V25.5731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3099 40.0652C55.2537 41.009 55.2537 42.5392 54.3099 43.4829L41.5357 56.2572C41.0825 56.7104 40.4677 56.965 39.8268 56.965C39.1858 56.965 38.5711 56.7103 38.1179 56.2571L32.6892 50.8277C31.7455 49.8838 31.7456 48.3537 32.6894 47.41C33.6332 46.4663 35.1634 46.4664 36.1071 47.4102L39.827 51.1306L50.8923 40.0652C51.836 39.1215 53.3662 39.1215 54.3099 40.0652Z",
    fill: "#004FCF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4995_34422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4995_34422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.7143,
    height: 50.4048,
    fill: "white",
    transform: "translate(18.6426 16.5723)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.5643c2a25d72e9dd40f65e137067f44b.svg";
export { ForwardRef as ReactComponent };